import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'noImagen'})
export class NoImagenPipe implements PipeTransform {
    transform(urlImg: any, urlImgAlternativa: string): any {
        if (!urlImg && urlImgAlternativa) return urlImgAlternativa
        if (!urlImg && !urlImgAlternativa) return 'favicon.ico';
        return urlImg;
    }
}